module.exports = __webpack_public_path__ + "./data/100Club_tables_0008.json";